import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
/** @jsxImportSource @emotion/react */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTypedSelector } from '@hook/common/useStore';
import ClozeHome from '@component/iyagigo/cloze/cloze-home';
import PageTemplate from '@page/iyagigo/page-template';
import Scroll from '@component/common/scroll';
import * as color from '@constant/color';

const TodayHomePage: React.FC<any> = () => {
  // ############### state ###############
  const studyLanguage = useTypedSelector((state) => state.rootReducer?.studentReducer?.currentStudyLanguage) ?? null;

  // ############### variable ###############
  const HEADER_TITLE = `${studyLanguage === EApiLanguageCode.ENGLISH ? '영어' : '일본어'} 빈칸문제`;

  // TODO: body level에서 background 색깔지정?
  return (
    <PageTemplate title={HEADER_TITLE} mode={'page'} backgroundColor={color.GRAY_BACKGROUND_COLOR}>
      <Scroll direction='y' height={`calc(100% - 10px)`}>
        <ClozeHome />
      </Scroll>
    </PageTemplate>
  );
};

export default TodayHomePage;
